import { getUpgradeLinkProps } from '@anm/helpers/upgradeLink';

export enum LimitName {
  storage = 'storage',
  traffic = 'traffic',
  embed = 'embedded videos',
  captions = 'auto captioning',
  text2speech = 'text-to-speech'
}

const getPrice = (cents = 0) => `${cents}¢`;

const getPricingLink = (text: string) => <a {...getUpgradeLinkProps()}>{text}</a>;

const upgradeToHigherLink = getPricingLink('upgrade to a higher plan.');
const upgradeToIncreaseLimitLink = getPricingLink('Upgrade to increase the limit.');

export const getUpgradeMessage = (name: LimitName) =>
  ({
    [LimitName.storage]: (
      <div>You are out of storage. Please remove some uploads to free up space or {upgradeToHigherLink}</div>
    ),
    [LimitName.embed]: (
      <div>You are out of embeddable videos. Please un-embed some videos or {upgradeToHigherLink}</div>
    ),
    [LimitName.traffic]: <div>You have reached your traffic limit. {upgradeToIncreaseLimitLink}</div>,
    [LimitName.captions]: <div>You have reached your auto captioning limit. {upgradeToIncreaseLimitLink}</div>,
    [LimitName.text2speech]: <div>You have reached your text to speech limit. {upgradeToIncreaseLimitLink}</div>
  }[name]);

const getChargeText = (price: string, itemToCharge: string) =>
  `You will be charged ${price} per month for every additional ${itemToCharge}.`;

const getExceedText = (name: LimitName, available: string, planName?: string) =>
  `You have exceeded the ${available} ${name} limit included with the ${planName} plan.`;

const getText = (name: LimitName, price: string, available: string, itemToCharge: string, planName?: string) =>
  `${getExceedText(name, available, planName)} <br> ${getChargeText(price, itemToCharge)}`;

export const getExtraChargeMessage = (
  name: LimitName,
  available: string,
  extraItemCost?: number,
  planName?: string
) => {
  const price = getPrice(extraItemCost);

  return {
    [LimitName.embed]: getText(name, price, available, 'embedded video', planName),
    [LimitName.storage]: getText(name, price, available, '1 GB', planName),
    [LimitName.traffic]: getText(name, price, available, '1 GB of traffic', planName),
    [LimitName.captions]: getText(name, price, available, '1 min of auto captioning', planName),
    [LimitName.text2speech]: getText(name, price, available, '1000 chars of text', planName)
  }[name];
};
